import { PrivateSettings } from '@wix/wix-vod-api-site-based/dist/src/private/services/settings/settings';
import {
  keysToSnakeCase,
  keysToCamelCase,
} from '@wix/wix-vod-shared/dist/src/common/utils/object';
import { toError } from 'api/parsers/transport-error';
import { catalogServiceConfig } from 'api/config/catalog-service';

function parseSuccessResponse({ data }) {
  if (!data) {
    throw Error('response data is not defined');
  }
  data = keysToCamelCase(data);

  let { createdTs, updatedTs } = data;

  createdTs = new Date(createdTs * 1000);
  updatedTs = new Date(updatedTs * 1000);

  return {
    ...data,
    createdTs,
    updatedTs,
  };
}

export const service = new PrivateSettings(catalogServiceConfig);

export const get = () =>
  service
    .get()
    .then(parseSuccessResponse)
    .catch(toError);

export const update = settings =>
  service
    .update(keysToSnakeCase(settings))
    .then(parseSuccessResponse)
    .catch(toError);
